import { Storage } from '@ionic/storage';

export let storage: null | Storage = null;

export async function initStorage() {
    storage = new Storage();
    await storage.create();
}